<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">カートプッシュの成果一覧</div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <div class="p-message-search">
            <form action="/" method="get">
              <div class="p-message-search-keyword">
                <button
                  :class="{ 'is-active': isSearchCondition }"
                  class="c-btn c-btn--gray u-w120 u-h32 u-fs--s"
                  type="button"
                  name="open_condition_detail"
                  value="open_condition_detail"
                  @click="onClickSearchCondition"
                >
                  <p class="c-btn__text">絞込み検索</p>
                </button>
              </div>
              <div
                class="p-message-search-condition"
                :class="{ 'is-active': isSearchCondition }"
              >
                <div class="c-title u-w1200 p-message-search-with-clear">
                  <div class="c-title__text u-fs22">絞り込み条件の追加</div>
                  <button
                    type="button"
                    name="search_exec"
                    value="search_exec"
                    class="c-btn c-btn--blue u-w200 u-h34 u-fs14"
                    style="margin-left: auto; margin-right: 20px;"
                    @click="onSearchClick($event)"
                  >
                    <p class="c-btn__text">検索実行</p>
                  </button>
                  <button
                    type="button"
                    name="clear"
                    value="clear"
                    class="c-btn c-btn--modal c-btn--gray u-w200 u-h34 u-fs14"
                    @click="onClickClearButton"
                  >
                    <p class="c-btn__text">条件クリア</p>
                  </button>
                </div>
                <div class="p-message-search-condition__row p-message-search-condition__row--dates" style="width: 800px; display: flex; align-items: center;">
                  <div class="c-input c-input--date-from" style="width: 100px;">
                    <label class="c-input__label">期間</label>
                  </div>
                  <div class="c-input" style="flex: 1; display: flex; align-items: center;">
                    <div class="c-input-group u-w220" style="display: inline-block;">
                      <datepicker
                        ref="refDateFrom"
                        v-model="dateFrom"
                        name="date_from"
                        format="yyyy/MM/dd"
                        placeholder="YYYY/MM/DD"
                        input-class="c-input__item c-input__item--overlay-ico u-w190"
                        calendar-class="datepicker_calendar"
                        :language="ja"
                      />
                      <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('date_from')">
                        <div class="c-icon c-icon--white u-wh20">
                          <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <use xlink:href="/assets/img/sprite.svg#calendar" />
                          </svg>
                        </div>
                      </div>
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                    <span style="margin: 0 10px;">〜</span>
                    <div class="c-input-group u-w220" style="display: inline-block;">
                      <datepicker
                        ref="refDateTo"
                        v-model="dateTo"
                        name="date_to"
                        format="yyyy/MM/dd"
                        placeholder="YYYY/MM/DD"
                        input-class="c-input__item c-input__item--overlay-ico u-w190"
                        calendar-class="datepicker_calendar"
                        :language="ja"
                      />
                      <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('date_to')">
                        <div class="c-icon c-icon--white u-wh22">
                          <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <use xlink:href="/assets/img/sprite.svg#calendar" />
                          </svg>
                        </div>
                      </div>
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>
          <div class="p-message-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">カートプッシュの成果が存在しません</div>
            </div>
            <table class="c-table cart-result">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">集計日</span>
                    <sort-switch name="summaryDate" :order="sortTargets.summaryDate" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">インプレッション</span>
                    <sort-switch name="displayCount" :order="sortTargets.displayCount" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">クリック数</span>
                    <sort-switch name="clickCount" :order="sortTargets.clickCount" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">CTR</span>
                    <sort-switch name="ctr" :order="sortTargets.ctr" @on-click="onClickSortButton($event)" />
                  </th>
                </tr>
              </thead>

              <!-- カート成果リスト -->
              <cart-service-result-list-item
                v-for="(summaryService,index) in summaryServices.data"
                :key="index"
                :summary-service="summaryService"
                @show-click="onShowService"
              />
              <!-- カート成果リスト -->
            </table>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
/**
 * カートプッシュの成果一覧ページ
 *
 * 仕様変更 (2025-10-06):
 * - 以前は periodType (1=月次, 2=週次, 3=日次) のラジオボタンがあり、
 *   各タイプごとに monthlyFrom/monthlyTo, weeklyFrom/weeklyTo, dailyFrom/dailyTo の
 *   3組の日付ピッカーが存在していた
 * - 仕様変更により periodType を廃止し、シンプルな日付範囲検索 (dateFrom/dateTo) のみに変更
 * - APIリクエストから period_type パラメータを削除
 * - 常に summary_service_daily テーブルを使用
 */
import Datepicker from '../molecules/Datepicker.vue';
const ja = 'ja';
import axios from 'axios';

export default {
  components: {
    Datepicker
  },
  props: {
    csrfToken: String,
    summaryInfo: [Object, String],
  },
  data () {
    return {
      // 仕様変更: periodType, monthlyFrom/To, weeklyFrom/To, dailyFrom/To を廃止
      dateFrom: null,
      dateTo: null,
      summaryServices: [],

      ja:ja,
      sortTargets: {
        summaryDate: -1,
        displayCount: 0,
        clickCount: 0,
        ctr: 0,
      },
      currentSortTarget: null,
      currentSortOrder: null,

      // フラグ系
      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      isSearchCondition: false,

      paginationInfo: null,
      page: 1,
      cr: "\n",
    }
  },
  computed: {
    parsedSummaryInfo: function() {
      if (typeof this.summaryInfo === 'string') {
        return JSON.parse(this.summaryInfo);
      }
      return this.summaryInfo;
    }
  },
  mounted: function() {
    import('../../funcs/pages/message').then(module => {
      module.Message();
      // デフォルト（月次・当月）でデータを読み込む
      this.loadData();
    });
  },
  methods: {
    loadData: function() {
      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0){
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      let from;
      let to;

      from = this.dateFrom ? this.getDateStringFromDateObject(this.dateFrom) : '';
      to = this.dateTo ? this.getDateStringFromDateObject(this.dateTo) : '';

      // 情報取得用パラメーター作成
      const params = {
        params: {
          sort: sortTarget,
          order: order,
          page: this.page,
        }
      };

      // fromとtoが設定されている場合のみパラメータに追加
      if(from && from !== ''){
        params.params.from = from;
      }
      if(to && to !== ''){
        params.params.to = to;
      }

      this.isLoading = true;
      this.isLoaded = false;

      // 配信状況データの取得処理実行
      axios.get('/api/analysis/summary/cart-service',params)
        .then(res => {
          this.summaryServices = res.data.items;
          this.paginationInfo = res.data.items;
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
            if (res.data.items.data.length < 1){
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = 'カート成果一覧の取得時にエラーが発生しました'
            this.isLoading = false;
          }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 検索条件ボタン
    onClickSearchCondition: function() {
      this.isSearchCondition = !this.isSearchCondition;
    },

    // クリック: リストのソートボタンクリック
    onClickSortButton: function(target) {
      //event.preventDefault();
      this.currentSortTarget = target;
      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 日付ボタン
    onShowService: function(summaryDate) {
      let url = this.parsedSummaryInfo.messageListUrl + '/' + summaryDate;
      location.href = url;
    },

    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },

    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteMessage = false;
      this.$refs.refControlModal.resetErrorMessage();
    },

    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    showCalendar: function(name) {
      const list = {
        date_from: 'refDateFrom',
        date_to: 'refDateTo',
      };

      Object.keys(list).forEach((key, _index) => {
        if (!this.$refs[list[key]]) return;
        if (name == key) {
          this.$refs[list[key]].$el.querySelector('input').focus();
          this.$refs[list[key]].showCalendar();
        } else {
          this.$refs[list[key]].close(true);
        }
      })
    },

    // 検索ボタンクリック
    onSearchClick: function(event) {
      event.preventDefault();
      this.page = 1;
      this.loadData();
    },

    // クリック: 条件クリアボタン
    onClickClearButton: function() {
      this.dateFrom = null;
      this.dateTo = null;
      this.page = 1;
      this.loadData();
    },

    // ページネーションボタンクリック処理
    // ページネーションコンポーネントからキックされる
    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.loadData();
    },
  }
}
</script>
